<template>
  <div class="container">
    <el-row v-if="esEdicion">
      <el-col :span="24">
        <div class="title">{{$t('PEDIDO_pedido')}}</div>
      </el-col>
    </el-row>
    <el-row v-else>
      <el-col :span="24">
        <div class="title">{{$t('PEDIDO_nuevo_pedido')}}</div>
      </el-col>
    </el-row>

    <el-row>
      <!-- Datos Pedido -->
      <el-col class="container_col_1" :xs="24" :sm="24" :md="7" :lg="7" :xl="7">
        <div class="contenedores">
          <el-card>
            <div v-if="inicializandoPedido === true">
              <div class="loaderContainer">
                <el-icon class="el-icon-loading"></el-icon>
                <div class="text">{{ $t('PEDIDO_inicializando_cabecera') }}</div>
              </div>
            </div>

            <div v-else class="card_body cabecera">
              <el-row type="flex" justify="end">
                  <div class="idCabecera">ID: {{ pedido.id }} </div>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="subtitulo">{{ $t('PEDIDO_numero_pedido') }}</div>
                  <div class="sub-title">{{ pedido.numero_pedido }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="24">
                  <div class="sub-title">{{ pedido.nombre_empresa }} ({{pedido.clave}})</div>
                </el-col>
              </el-row>

              <el-divider></el-divider>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('PEDIDO_instancia')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel">{{ descripcionInstancia }}</div>
                </el-col>
              </el-row>

              <el-row v-if="this.esEdicion">
                <el-col :span="10">
                  <div class="label">{{$t('PEDIDO_ingresadoPor')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel">{{ pedido.ingresadoPor }}</div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('GENERAL_fecha')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="greyLabel">{{pedido.fecha}}</div>
                </el-col>
              </el-row>

              <el-row style="margin-bottom: 10px">
                <el-col :span="10">
                  <div class="label">{{$t('PEDIDO_plazo_pago')}}:</div>
                </el-col>

                <el-col :span="14">
                  <div class="select">
                    <el-select
                      :disabled="!permitirEditar"
                      size="small"
                      v-model="pedido.plazoDePago"
                      :placeholder="$t('GENERAL_seleccione')"
                      @change="interes_porcentaje"
                    >
                      <el-option
                        v-for="pago in plazosPago"
                        :key="pago.Clave"
                        :value="pago.Clave"
                        :label="pago.Descripcion"
                      ></el-option>
                    </el-select>
                  </div>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('PEDIDO_nota_comercial')}}:</div>
                </el-col>
                <el-col :span="14">
                  <el-input
                    class="textarea"
                    type="textarea"
                    v-model="pedido.notaComercial"
                    :disabled="!permitirEditar"
                    :rows="4"
                    @change="notaComercial"
                  ></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <div class="label">{{$t('PEDIDO_importe')}}:</div>
                </el-col>
                <el-col :span="14">
                  <div class="greyLabel">{{pedido.moneda}}</div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>

        <div v-if="permitirEditar" class="btnContainer pedido">
          <div class="contenedores importacionDetalles">
            <div class="subtitulo">{{ $t('PEDIDO_importar_subtitle') }}</div>

            <el-card>
              <div v-if="estadoProcesoImportacion === 0">
                <div class="label">
                  {{ $t('PEDIDO_importar_msg') }}
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="$t('PEDIDO_importar_ejemplo_archivo')"
                    placement="top"
                  >
                    <i class="el-icon-question" @click="dialogEjemploImportacion=true"></i>
                  </el-tooltip>
                </div>

                <div class="fileUploadContainer">
                  <FileUpload
                    name="importarDetallePedido"
                    :labelTag="$t('PEDIDO_importar_seleccione_btn')"
                    :files="archivosDetallePedido"
                    storeAction="pedidos/uploadArchivoDetalles"
                    :temporalId="pedido.id"
                    :onFileListChange="onFileChanged"
                    :accept="',.xls,.xlsx'"
                    :limit="1"
                  />
                </div>

                <div v-if="archivosDetallePedido.length > 0">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="importarDetalles"
                  >{{ $t('PEDIDO_importar_importarBtn') }}</el-button>
                </div>
              </div>

              <div v-else-if="estadoProcesoImportacion === 1">
                <div class="loaderContainer">
                  <el-icon class="el-icon-loading"></el-icon>
                  <div class="text">{{ $t('PEDIDO_importar_procesandoMsg') }}</div>
                </div>
              </div>

              <div v-else-if="estadoProcesoImportacion === 2">
                <div class="resultadoExportacion">
                  <div
                    class="filasProcesadas"
                  >{{ `${resultadoImportacion.FilasProcesadas} ${$t('PEDIDO_importar_filasProcesadas')}` }}</div>
                  <div
                    class="filasExitosas"
                  >{{ `${resultadoImportacion.FilasProcesadas - resultadoImportacion.FilasConError} ${$t('PEDIDO_importar_filasExitosas')}` }}</div>
                  <div class="filasConError">
                    {{ `${resultadoImportacion.FilasConError} ${$t('PEDIDO_importar_filasConError')}` }}
                    <el-tooltip
                      v-if="resultadoImportacion.FilasConError > 0"
                      class="item"
                      effect="dark"
                      :content="$t('PEDIDO_errores_importacion_titulo')"
                      placement="top"
                    >
                      <i
                        class="el-icon-info"
                        style="cursor:pointer;"
                        @click="dialogErrorImportacion=true"
                      ></i>
                    </el-tooltip>
                  </div>
                </div>

                <el-button
                  type="primary"
                  size="mini"
                  @click="nuevaImportacionDetalles"
                >{{ $t('PEDIDO_importar_nuevaImportacionBtn') }}</el-button>
              </div>
            </el-card>
          </div>
        </div>
      </el-col>

      <!-- Datos Productos -->
      <el-col class="container_col_2" :xs="24" :sm="24" :md="17" :lg="17" :xl="17">
        <div class="contenedores">
          <el-card :body-style="{ padding: '0px' }">
            <div class="card_body">
              <div class="bordes_body">
                <el-row>
                  <el-col :span="permitirEditar ? 22 : 17">
                    <div class="subtitulo">{{$t('PRODUCTO_productos_seleccionados')}}</div>
                  </el-col>
                  <el-col v-if="permitirEditar" :span="2">
                    <div class="iconContainer" @click="agregarProducto">
                      <el-tooltip  class="item" effect="dark" :content="$t('PRODUCTO_agregar')" placement="top-start">
                        <i class="el-icon-circle-plus"></i>
                      </el-tooltip>
                    </div>
                  </el-col>
                  <el-col v-else :span="7" type="flex" align="end" >
                    <div v-show="productos.length > 0 && !esPedidoSinConfirmar">
                      <el-switch
                        style="text-align: start"
                        v-model="filtrarDespachados"
                        :active-text="$t('PEDIDO_filtroFaltanDespachar')"
                      >
                      </el-switch>
                    </div>
                  </el-col>
                </el-row>
              </div>
              <el-divider></el-divider>

              <el-row>
                <el-col :span="24">
                  <!-- Productos -->
                  <div class="card_list">
                    <div v-if="productos.length > 0">
                      <div
                        class="card_list_item"
                        v-for="(producto, index) in getProductos"
                        :key="index"
                      >
                        <ProductoSeleccionadoCard
                          :permitirEditar="permitirEditar"
                          :producto="producto"
                          :esExento="esExento"
                          @datosPedido="actualizarDatosPedido"
                          @eliminarProducto="eliminarProductoSeleccionado"
                          @cambiarEditar="cambiarEditar"
                        />
                      </div>
                    </div>
                    <div v-else class="loader">{{$t('PRODUCTO_agregar_producto')}}<i class="el-icon-circle-plus"/></div>
                  </div> 
                </el-col>
              </el-row>

              <!-- Detalle del pedido -->
              <div v-show="this.productos.length > 0" class="detallePedido">
                <el-row>
                  <el-col :span="12">
                    <div class="blackLabel col1">{{$t('PEDIDO_subtotal')}}</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blackLabel precio">{{ decimalToString(pedido.subtotal) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PEDIDO_bonificacion')}}</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="label precio">{{ decimalToString(pedido.bonificacion) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PEDIDO_porcentaje_descuento')}}</div>
                  </el-col>
                  <el-col :span="4">
                    <!-- <div class="label precio">{{porcentaje}}</div> -->
                    <div class="label precio">{{ pedido.descuentoPorcentaje }}%</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="label precio">{{ decimalToString(pedido.descuento) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PEDIDO_intereses')}}</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="label precio">{{ pedido.interesPorcentaje }}%</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="label precio">{{ decimalToString(pedido.interesTotal) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="blackLabel col1">{{$t('PEDIDO_neto')}}</div>
                  </el-col>
                  <el-col :span="12">
                    <div class="blackLabel precio">{{ decimalToString(pedido.neto) }}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PEDIDO_iva')}}</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="label precio">{{ pedido.ivaPorcentaje }}%</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="label precio">{{ decimalToString(pedido.ivaTotal)}}</div>
                  </el-col>
                </el-row>
                <el-divider></el-divider>
                <el-row>
                  <el-col :span="12">
                    <div class="label col1">{{$t('PEDIDO_iva_reducido')}}</div>
                  </el-col>
                  <el-col :span="4">
                    <div class="label precio">{{ pedido.ivaRedPorcentaje }}%</div>
                  </el-col>
                  <el-col :span="8">
                    <div class="label precio">{{ decimalToString(pedido.ivaReducidoTotal) }}</div>
                  </el-col>
                </el-row>
              </div>

              <el-row class="total">
                <el-col :span="10">
                  <div class="label col1">{{$t('PEDIDO_importe_final')}} ({{ pedido.moneda }})</div>
                </el-col>
                <el-col :span="14 ">
                  <div class="label precio">{{ decimalToString(pedido.importeFinal) }} *</div>
                </el-col>
              </el-row>
            </div>
          </el-card>
        </div>

        <el-row>
          <el-col :span="12" style="text-align: left;" class="label leyenda">
            {{$t('PEDIDO_cantidad_item')}}: {{productos.length}}
          </el-col>
          <el-col
            :span="12"
            class="label leyenda precio"
            style="text-align: right; padding-right: 20px;"
          >*{{$t('PEDIDO_sin_impuesto_ingresos_brutos')}}</el-col>
        </el-row>

        <div v-if="existeBaseDolar">
          <el-row >
            <el-col
              :md="23"
              class="label leyenda precio"
            >{{$t('PEDIDO_referencia_base_dolar')}}</el-col>
          </el-row>
        </div>
        
        <el-row>
          <el-col :md="24">
            <div class="btnContainer pedido">
              <el-button
              type="primary"
              icon="el-icon-check"
              v-if="sinEditar"
              @click="onConfirmarPedido"
              >{{ $t('PEDIDO_confirmarPedidoBtn') }}
              </el-button>
              <el-button
                type="primary"
                v-else-if="permitirEditar"
                @click="save"
                :loading="guardado">{{ $t('GENERAL_saveBtn') }}
              </el-button>
              <el-button
                type="primary"
                v-if="pedido.instanciaPedido == '2A'"
                @click="volverAIngreso"
                :loading="guardado"
                >{{ $t('PEDIDO_volverAIngresoBtn') }}
              </el-button>
              <el-button  @click="cancelarPedido">{{ $t('GENERAL_cancelBtn') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <AgregarProductoDialog
      :pantallaOrigen="'Pedido'"
      :visible="view_productos"
      :onClose="onCloseCancelar"
      :productosAgregados="productos"
      :subtotal="this.pedido.subtotal"
      @agregarProductosSeleccionados="agregarProductosSeleccionados"
      ref="dialogAgregarProducto"/>

    <Dialog
      :visible="codigo_producto_a_eliminar !== undefined"
      :title="$t('PRODUCTO_eliminar')"
      :message="eliminar_producto_msg"
      :onClose="onCloseEliminarConfirmation"/>

    <Dialog
      :visible="this.cancelar"
      :title="$t('GENERAL_desea_cancelar')"
      :message="cancelar_msg"
      :onClose="onCloseCancelarConfirmation"/>

    <!-- Ejemplo de importacion -->
    <el-dialog
      :title="$t('PEDIDO_importar_ejemplo_titulo')"
      :visible.sync="dialogEjemploImportacion"
      width="25%">
      <div>
        <el-row style="text-align:center !important;">
          <img style="width:100%" src="../../images/ejemplo_importacion.png" />
        </el-row>
        <el-row>
          <div class="label">{{$t('PEDIDO_importar_ejemplo_indicaciones')}}</div>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogEjemploImportacion = false">{{$t('GENERAL_acceptBtn')}}</el-button>
      </span>
    </el-dialog>

    <!-- Errores de importacion -->
    <el-dialog
      :title="$t('PEDIDO_errores_importacion_titulo')"
      :visible.sync="dialogErrorImportacion"
      width="50%"
      top="1vh">

      <!-- Tablas -->

      <el-table
        class="nuevo-pedido"
        :data="this.listC"
        style="width: 100%; max-height:400px"
        :header-cell-style="tableHeaderColor"
        height="210"
        >
        <el-table-column
        prop="error"
        label="Detalles de error">
        </el-table-column>
      </el-table>

      <div>
        <el-table
        v-if="this.listB.length > 0"
        class="label"
        ref="multipleTable"
        :header-cell-style="tableHeaderColor"
        :data="this.listB"
        style="width: 100%;  max-height:400px"
        height="210"
        @selection-change="handleSelectionChange"
        >
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          property="Clave"
          label="Producto"
          width="120">
        </el-table-column>
        <el-table-column
          property="Leyenda"
          label="Detalles"
          min-width="350">
        </el-table-column>
        <el-table-column
          property="Cantidad"
          label="Cantidad"
          width="80">
        </el-table-column>
      </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-row >
          <el-col :xs="12" :sm="19" :md="19" :lg="19" :xl="19" >
            <el-button type="primary" @click="listB.length > 0? dialogError():(dialogErrorImportacion = false)"
              :style="listB.length > 0?'font-size:70%':''">
              {{$t(listB.length > 0?'GENERAL_agregar_continuar':'GENERAL_acceptBtn')}}
              </el-button>
          </el-col>
          <el-col :xs="12" :sm="3" :md="3" :lg="3" :xl="3">
            <el-button  @click="dialogErrorImportacion = false">{{ $t('GENERAL_cancelBtn') }}</el-button>
          </el-col>
        </el-row>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ProductoSeleccionadoCard from "@/components/Cards/productoSeleccionadoCard";
import AgregarProductoDialog from "../Dialog/agregarProducto";
import FileUpload from "../FileUpload/index";
import Dialog from "../Dialog";
import { mapState } from "vuex";
import { showError, showSuccess } from "../Mensaje";
import { mostrarMensajeInternacionalizado } from "../MensajeInternacionalizado";
import { decimalToString } from "../Helpers/commonFunctions";

export default {
  name: "AltaPedido",
  components: {
    ProductoSeleccionadoCard,
    AgregarProductoDialog,
    Dialog,
    FileUpload
  },
  props: {
    permitirEditar: Boolean
  },
  data() {
    return {
      plazosPago: [],
      productos: [],

      inicializandoPedido: true,
      pedido: {
        id: 0,
        instanciaPedido: "",
        numero_pedido: 0,
        nombre_empresa: "",
        fecha: `${new Date().getDate()}/${(new Date().getMonth() + 1)
          .toString()
          .padStart(2, "0")}/${new Date().getFullYear()}`,
        plazoDePago: undefined,
        clavePlazo: undefined,
        notaComercial: "",
        interes_porcentaje: 0,
        moneda: undefined,
        exentoIVA: false,
        numero: 0,
        subtotal: 0,
        descuento: 0,
        bonificacion: 0,
        descuentoPorcentaje: 0,
        interesPorcentaje: 0,
        interesTotal: 0,
        ivaPorcentaje: 21.0,
        ivaTotal: 0,
        ivaRedPorcentaje: 10.5,
        ivaReducidoTotal: 0,
        importeFinal: 0,
        neto: 0,
        clave: undefined,
        ingresadoPor: undefined,
      },

      detalles:undefined,
      listB: [],
      listC: [],
      listRC: [],
      checkProducto: {
        B: [],
      },

      esExento: false,


      cancelar_msg: "",
      cancelar: false,

      loading: false,
      view_productos: false,
      codigo_producto_a_eliminar: undefined,
      eliminar_producto_msg: "",
      datosProductoActualizar: undefined,
      producto_a_eliminar: undefined,
      esEdicion: false,
      guardado: false,
      sinEditar: false,

      // importación de archivos
      archivosDetallePedido: [],
      estadoProcesoImportacion: 0,
      resultadoImportacion: undefined,
      erroresImportacion: undefined,
      dialogEjemploImportacion: false,
      dialogErrorImportacion: false,
      promises : [],

      // filtrar por despachados
      filtrarDespachados: false

    };
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario
    }),

    descripcionInstancia() {
      let descripcion = "";

      switch (this.pedido.instanciaPedido) {
        case "0A":
        case "1A":
          descripcion = this.$t("PEDIDO_instancia_sin_confirmar");
          break;

        case "A":
        case "AE":
        case "B":
        case "B1":
        case "B2":
        case "C":
        case "D":
        case "E":
        case "P":
        case "R":
          descripcion = this.$t("PEDIDO_instancia_proceso");
          break;

        case "X":
        case "Z":
          descripcion = this.$t("PEDIDO_instancia_historico");
          break;

        case "2A":
          descripcion = this.$t("PEDIDO_instancia_confirmado");
          break;

        default:
          descripcion = "";
      }

      return `(${this.pedido.instanciaPedido}) ${descripcion}`;
    },
    esPedidoSinConfirmar()
    {
      return this.pedido.instanciaPedido.match("0A|1A");
    },
    existeBaseDolar: function() {
      let flag = false;
      this.productos.forEach(producto => {
        if (producto.Moneda != "")
          flag = true;
      });

      return flag;
    },
    getProductos()
    {
      if(this.filtrarDespachados)
        return this.productos.filter(producto => producto.Cantidad > producto.CantidadDespachada);
      else
        return this.productos;
    }
  },

  methods: {
    decimalToString: decimalToString,
    init(){
      // armo el payload
        let payload = { }
        payload.idUsuario = this.idUsuario

      // busco los plazos de pago
      this.$store
        .dispatch("pedidos/getPlazosPago", payload)
        .then(data => (this.plazosPago = data));

      if (this.$route.params.id) {
        // indico que es una edición de Pedido
        this.esEdicion = true;
        // busco el Pedido a editar
        this.$store
          .dispatch("pedidos/getPedido", { id: this.$route.params.id, idUsuario: this.idUsuario })
          .then(data => {
            if (data.CodigoResultado === 0) {
              var pedido = JSON.parse(data.Datos);
              this.cargarPedido(pedido);
            } else {
              mostrarMensajeInternacionalizado(
                data.CodigoResultado,
                data.DescripcionResultado
              );
            }
          })
          .finally(() => {
            this.loading = false;
            this.inicializandoPedido = false;
          });
      } else {
        // indico que se está inicializando el pedido
        this.inicializandoPedido = true;

        // nuevo pedido
        this.$store
          .dispatch("pedidos/iniciarPedido", { idUsuario: this.idUsuario })
          .then(data => {
            if (data.CodigoResultado === 0) {
              // inicializo la cabecera del pedido
              let cabecera = JSON.parse(data.Datos);
              this.pedido.id = cabecera.Id;
              this.pedido.clave = cabecera.Clave;
              this.pedido.numero_pedido = cabecera.Numero;
              this.pedido.nombre_empresa = cabecera.Empresa;
              this.pedido.instanciaPedido = cabecera.Instancia;
              this.pedido.plazoDePago = undefined;
              this.pedido.interes_porcentaje = cabecera.PlazoPago.Interes_Porcentaje;
              this.pedido.notaComercial = cabecera.NotaComercial;
              this.pedido.exentoIVA = cabecera.ExentoIva;
              this.esExento = cabecera.ExentoIva;
              if (cabecera.Moneda != null) this.pedido.moneda = cabecera.Moneda;
              else this.pedido.moneda = "ARS";
            } else {
              mostrarMensajeInternacionalizado(
                data.CodigoResultado,
                data.DescripcionResultado
              );
            }
          })
          .finally(() => (this.inicializandoPedido = false));
      }

    },
    agregarProducto() {
      this.view_productos = true;
      this.sinEditar = false;
    },

    handleSelectionChange(val) {
      this.checkProducto.B = val;
    },

    dialogError(){
      let productosB = this.checkProducto.B;
      this.agregarProductosSeleccionados(productosB);
      productosB.forEach(element => {
        this.eliminarProductoLista(element)
      });
      this.dialogErrorImportacion = false;
      this.checkProducto.B = [];
    },

    eliminarProductoLista(producto) {
        if(this.listB.length === 1) this.listB = [];
        else
          this.listB.splice(
            this.listB.indexOf(producto),
            1
          );
      this.resultadoImportacion.FilasConError--;
    },

    agregarProductosSeleccionados(productos) {
      productos.forEach(element => {
        this.productos.push(element);
      });
    },

    onCloseCancelar(confirm) {
      // si confirmó el diálogo, guardo el pedido
      if (confirm) {
        this.savepedido();
      }
      this.view_productos = false;
    },

    cambiarEditar(sinEditar){
      this.sinEditar = sinEditar;
    },

    notaComercial(){
      this.sinEditar = false;
    },

    interes_porcentaje() {
      this.sinEditar = false;
      this.pedido.descuentoPorcentaje = 0;
      this.pedido.interesPorcentaje = 0;
      this.pedido.clavePlazo = this.pedido.plazoDePago;

      this.plazosPago.forEach(element => {
        if (element.Clave == this.pedido.plazoDePago) {
          if (element.Interes_Porcentaje >= 0) {
            this.pedido.interesPorcentaje = element.Interes_Porcentaje;
          } else
            this.pedido.descuentoPorcentaje = element.Interes_Porcentaje * -1;

          this.pedido.subtotal = 0;
          this.pedido.bonificacion = 0;
          this.pedido.ivaTotal = 0;
          this.pedido.ivaReducidoTotal = 0;

          this.productos.forEach(producto => {
            let datosProducto = {
              Cantidad: producto.Cantidad,
              precioUnitario: producto.Precio,
              IVA: producto.IVA,
              BonificacionImporte: producto.BonificacionPorcentaje * producto.Precio,
              BonificacionPorcentaje: producto.BonificacionPorcentaje
            };
            this.actualizarDatosPedido(datosProducto);
          });
        }
      });
    },

    filtrar() {
      this.view_productos = false;
    },

    actualizarDatosPedido(datosProducto) {
      //ACTUALIZA EL SUBTOTAL DEL PEDIDO, SUMANDO O RESTANDO DEPENDIENDO DEL VALOR DE 'PRODUCTO.CantidadSeleccionada'
      var subtotal = datosProducto.Cantidad * datosProducto.precioUnitario
      this.pedido.subtotal +=
        parseFloat((subtotal).toFixed(2));

      //Bonificacion Total
      var bonificacionRedond =
        datosProducto.Cantidad *
        datosProducto.precioUnitario *
        (datosProducto.BonificacionPorcentaje / 100);
      this.pedido.bonificacion += parseFloat((bonificacionRedond).toFixed(2));

      //Bonifiacion por producto
      var bonificacion =
        parseFloat((datosProducto.Cantidad *
        datosProducto.precioUnitario *
        (datosProducto.BonificacionPorcentaje / 100)).toFixed(2));


      //Interés Total
      this.pedido.interesTotal =
        parseFloat(((this.pedido.subtotal - this.pedido.bonificacion) *
        (this.pedido.interesPorcentaje / 100)).toFixed(2));

      //Interés por producto
      var interes =
        parseFloat(((datosProducto.Cantidad * datosProducto.precioUnitario - bonificacion) *
        (this.pedido.interesPorcentaje / 100)).toFixed(2));

      //Descuento Total
      this.pedido.descuento =
        parseFloat((
          (this.pedido.subtotal - this.pedido.bonificacion) *
          (this.pedido.descuentoPorcentaje / 100)).toFixed(2));

      //Descuento por producto
      var descuento =
        parseFloat(((datosProducto.Cantidad * datosProducto.precioUnitario - bonificacion) *
        (this.pedido.descuentoPorcentaje / 100)).toFixed(2));


      this.pedido.neto =
        this.pedido.subtotal -
        this.pedido.bonificacion -
        this.pedido.descuento +
        this.pedido.interesTotal;

      if(this.pedido.exentoIVA)
      {
        this.pedido.ivaTotal = 0;
        this.pedido.ivaReducidoTotal = 0;
      } else
      {
        if (datosProducto.IVA == 21.0)
          this.pedido.ivaTotal +=
            parseFloat(((datosProducto.Cantidad * datosProducto.precioUnitario -
              bonificacion -
              descuento +
              interes) *
            (datosProducto.IVA / 100)).toFixed(2));
        else
          this.pedido.ivaReducidoTotal +=
            parseFloat(((datosProducto.Cantidad * datosProducto.precioUnitario -
              bonificacion -
              descuento +
              interes) *
            (datosProducto.IVA / 100)).toFixed(2));
        }
        if (this.productos.length === 0) this.pedido.importeFinal = 0;
        else
          this.pedido.importeFinal =
            this.pedido.neto +
            this.pedido.ivaTotal +
            this.pedido.ivaReducidoTotal;
    },

    cancelarPedido() {
      if(this.idPedido == 0){
        let mensaje = this.$t("GENERAL_cancelar_mensaje");
        this.cancelar_msg = mensaje;
        this.cancelar = true;
      }
     else{
       this.$router.push({
          name: 'Pedidos',
          params: { keepFilter: true }
        });
      }
    },

    eliminarProductoSeleccionado(producto, datosProducto) {
      let mensaje = this.$t("PRODUCTO_eliminar_mensaje");
      mensaje = mensaje.replace("[codigo]", producto.Nombre);
      this.eliminar_producto_msg = mensaje;

      this.codigo_producto_a_eliminar = producto.Nombre;
      this.producto_a_eliminar = producto;
      this.datosProductoActualizar = datosProducto;
    },

    onCloseEliminarConfirmation(confirm) {
      // si confirmó el diálogo, elimino
      if (confirm) {
        this.eliminarProducto();
      }

      // limpio los valores del diálogo
      this.codigo_producto_a_eliminar = undefined;
      this.eliminar_producto_msg = "";
    },

    onCloseCancelarConfirmation(confirm) {
      // si confirmó el diálogo, elimino
      if (confirm) {
        this.$router.push({
          name: 'Pedidos',
          params: { keepFilter: true }
        });
      }

      // limpio los valores del diálogo
      this.cancelar = false;
      this.cancelar_msg = "";
    },

    eliminarProducto() {
      if (this.productos.length === 1) this.productos = [];
      else
        this.productos.splice(
          this.productos.indexOf(this.producto_a_eliminar),
          1
        );
      this.sinEditar = false;
      this.actualizarDatosPedido(this.datosProductoActualizar);
    },

    cargarPedido(pedido) {
      // cargo el pedido a editar
      // Datos Pedido
      this.pedido.id = pedido.Id;
      this.pedido.clave = pedido.Clave;
      this.pedido.numero_pedido = pedido.Numero;
      this.pedido.instanciaPedido = pedido.Instancia;
      this.pedido.ingresadoPor = pedido.CreadoPor;
      this.pedido.fecha = pedido.FechaStr;
      this.pedido.plazoDePago = pedido.PlazoPago.Descripcion === "" ? undefined : pedido.PlazoPago.Descripcion;
      this.pedido.notaComercial = pedido.NotaComercial;
      this.pedido.nombre_empresa = pedido.Empresa;
      this.pedido.clavePlazo = pedido.PlazoPago.Clave === "" ? undefined : pedido.PlazoPago.Clave;
      this.pedido.exentoIVA = pedido.ExentoIva;
      if (pedido.Moneda != null) this.pedido.moneda = pedido.Moneda;
      else this.pedido.moneda = "ARS";

      // Detalle Pedido
      if (this.permitirEditar) {
        this.pedido.subtotal = 0;
        this.pedido.descuento = 0;
        this.pedido.bonificacion = 0;
        this.pedido.interesTotal = 0;
        this.pedido.ivaTotal = 0;
        this.pedido.ivaReducidoTotal = 0;
      } else {
        this.pedido.subtotal = pedido.Subtotal;
        this.pedido.descuento = pedido.DescuentoImporte;
        this.pedido.bonificacion = pedido.Bonificacion;
        this.pedido.interesTotal = pedido.InteresImporte;
        this.pedido.ivaTotal = pedido.IVAImporte;
        this.pedido.ivaTotal = pedido.IVAImporte;
        this.pedido.ivaReducidoTotal = pedido.IVAReducidoImporte;
        this.pedido.neto = pedido.ImporteNeto;
        this.pedido.importeFinal = pedido.ImporteTotal;
      }

      this.pedido.descuentoPorcentaje = pedido.DescuentoPorcentaje;
      this.pedido.interesPorcentaje = pedido.InteresPorcentaje;
      this.pedido.ivaPorcentaje = pedido.IVAPorcentaje;
      this.pedido.ivaRedPorcentaje = pedido.IVAReducidoPorcentaje;

      if (pedido.Instancia == "0A")
              this.sinEditar = true;

      // genero la misma estructura para los detalles de pedido y los cargo
      let detalles = pedido.Detalles.map(x => {
        return {
          ...x,
          Bonificacion: x.BonificacionPorcentaje,
          Promocion: x.Promocion,
          Nombre: x.Producto.Clave,
          Clave: x.Producto.Clave,
          Descripcion: x.Producto.Descripcion
        };
      });
      this.agregarProductosSeleccionados(detalles);
    },

    save() {
      // indico que se está guardado el pedido
      this.guardado = true;
      // validaciones
      let valida = true;

      if (this.productos.length === 0) {
        showError(this.$t("PEDIDO_producto_missing"));
        valida = false;
      }

      if (this.pedido.plazoDePago === undefined) {
        showError(this.$t("PEDIDO_plazo_pago_missing"));
        valida = false;
      }

      if (!valida) {
        this.guardado = false;
        return;
      }

      // armo el payload
      let payload = {
        IdUsuario: this.idUsuario,
        IdPedido: this.pedido.id,
        ClavePlazoPago: this.pedido.plazoDePago,
        NotaComercial: this.pedido.notaComercial,
        Detalles: this.productos.map(x => {
          return {
            Id: x.Id || 0,
            ClaveProducto: x.Clave != undefined ? x.Clave : x.Producto.Clave,
            Cantidad: x.Cantidad,
            NotaTecnica: x.NotaTecnica || ""
          };
        })
      };

      if (this.esEdicion) payload.ClavePlazoPago = this.pedido.clavePlazo;
      // persisto el pedido
      this.$store
        .dispatch("pedidos/savePedido", payload)
        .then(data => {
          if (data.CodigoResultado === 0) {
            this.$router.push({
              name: "ConfirmarPedido",
              params: { id: this.pedido.id }
            });
          } else {
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
          }
        })
        .finally(() => (this.guardado = false));
    },

    volverAIngreso(){
      // recupero el id del pedido
        let idPedido = this.$route.params.id

      //regreso el pedido a Ingresado
      this.$store.dispatch('pedidos/volverAIngreso', { id: idPedido })
        .then(data =>
        {
          if(data.CodigoResultado === 0)
          {
            // indico que es una edición de Pedido
            this.esEdicion = true;

            // busco el Pedido a editar
            this.$store
            .dispatch("pedidos/getPedido", { id: this.$route.params.id, idUsuario: this.idUsuario })
            .then(response => {
              if (response.CodigoResultado === 0) {
                var pedido = JSON.parse(response.Datos);
                this.permitirEditar = true;
                this.pedido.instanciaPedido = pedido.Instancia;
                //Scroll para Android
                document.body.scrollTop = 0;
                //Scroll para IOS
                document.documentElement.scrollTop = 0;
                showSuccess(this.$t('PEDIDO_success'));
              } else {
                mostrarMensajeInternacionalizado(
                  data.CodigoResultado,
                  data.DescripcionResultado
                );
              }
            })
            .finally(() => {
              this.loading = false;
              this.inicializandoPedido = false;
            });
          }
          else{
            mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado)
          }
        });
    },
    onFileChanged(name, fileList) {
      this.archivosDetallePedido = fileList;
    },
    importarDetalles() {
      // indico que se está procesando el archivo
      this.estadoProcesoImportacion = 1;

      // llamo a la lógica de procesamiento del archivo importado
      this.$store
        .dispatch("pedidos/importarDetallesPedido", { id: this.pedido.id, idUsuario: this.idUsuario })
        .then(async (data) => {
          if (data.CodigoResultado === 0) {
            // indico que se edito el pedido
            this.sinEditar = false;
            // recupero las estadísticas de la importación
            let datos = JSON.parse(data.Datos);
            this.resultadoImportacion = datos.ResultadoImportacion;

            // genero la misma estructura para los detalles de pedido y los cargo
            this.detalles = datos.Detalles.map(x => {
              return {
                ...x,
                Nombre: x.Producto.Clave,
                Clave: x.Producto.Clave,
                Descripcion: x.Producto.Descripcion
              };
            });

            let productosAux = this.detalles.map(x => { return{
              Nombre: x.Nombre == undefined? x.Producto.Clave:x.Nombre,
              Clave: x.Clave,
              Cantidad: x.Cantidad,
              Precio: x.Precio,
              IVA: x.IVA,
              BonificacionImporte: x.BonificacionImporte == undefined? 0:x.BonificacionImporte,
              BonificacionPorcentaje: x.BonificacionPorcentaje,
              UnidadMedida: x.UnidadMedida,
              AdmiteDecimales: x.AdmiteDecimales,
              Leyenda:x.Leyenda,
              EstadoVenta:x.EstadoVenta,
              Promocion: x.Promocion,
              Descripcion:x.Descripcion};
            });

            this.getErroresImportacion();

            for(const producto of productosAux){
             // await this.validarEstadoVenta(producto);
             await this.validarEstadoVenta(producto);
            }

            this.estadoProcesoImportacion = 2;
          } else {
            mostrarMensajeInternacionalizado(
              data.CodigoResultado,
              data.DescripcionResultado
            );
            this.nuevaImportacionDetalles();
          }
        });
    },
    getErroresImportacion() {
      if (this.resultadoImportacion.ErroresImportacion.length > 0) {
        this.erroresImportacion = this.resultadoImportacion.ErroresImportacion.map(
          error => {

            let RowNumber = error.split("|")[0];
            let Message = this.$t(
                  "PEDIDO_error_importar_" + error.split("|")[1]
                );
            if(RowNumber != "0")
              Message = Message.replace("[fila]", RowNumber)
            else
              Message = error.split("|")[1]
            this.listC.push({error: Message});
            return Message;
          }
        );

      }
    },
    validarEstadoVenta(producto) {
     switch(producto.EstadoVenta){
      case "B":
      case "C":
        if (producto.EstadoVenta == "B") {

          if(producto.Leyenda != ""){
            let aux = this.listB.filter(x => {return x.Clave == producto.Clave;});
            let aux2 = this.detalles.filter(x => {return x.Clave == producto.Clave;});
            if (aux.length > 0 || (aux.length > 0 && aux2.length > 1))
              producto.Leyenda = producto.Leyenda + " (REPETIDO)";
            this.listB.push(producto);
            this.resultadoImportacion.FilasConError++;
          }
          else{
            this.productoRepetido(producto);
          }

        }
        else{
          let aux = this.listRC.filter(x => {return x.Clave == producto.Clave;});
          let aux2 = this.detalles.filter(x => {return x.Clave == producto.Clave;});
          let mensaje = ""
          if (aux.length > 0 || (aux.length > 0 && aux2.length > 1))
            mensaje = producto.Clave + ": " + producto.Leyenda + " (REPETIDO)";
          else
            mensaje = producto.Clave + ": " + producto.Leyenda;
          this.listRC.push(producto);
          this.listC.push({error: mensaje});
          this.resultadoImportacion.FilasConError++;
        }
        break;

      default:
        this.productoRepetido(producto);
        break;
      }
    },
    productoRepetido(producto) {
      let aux = this.productos.filter(x => {return x.Clave == producto.Clave;});
      let aux2 = this.detalles.filter(x => {return x.Clave == producto.Clave;});

      if (aux.length > 0 || (aux.length > 0 && aux2.length > 1)) {
        producto.Leyenda = "Repetido";
        this.listB.push(producto);
        this.resultadoImportacion.FilasConError++;
      } else {
        //Agregar a la lista de productos
          this.productos.push(producto);
      }
    },
    nuevaImportacionDetalles() {
      // inicializo las variables de importación de detalles
      this.estadoProcesoImportacion = 0;
      this.archivosDetallePedido = [];
      this.resultadoImportacion = undefined;
    },
    onConfirmarPedido()
    {
      // indico que se está confirmando el pedido
      this.estadoProcesoConfirmacion = 1

      // recupero el id del pedido
      let idPedido = this.$route.params.id

      let tieneErrores = false;

      if (this.productos.length === 0) {
      showError(this.$t("PEDIDO_producto_missing"));
      tieneErrores = true;
      }

      if (this.pedido.plazoDePago === undefined) {
        showError(this.$t("PEDIDO_plazo_pago_missing"));
        tieneErrores = true;
      }

      if(tieneErrores)
      {
          // vuelvo al estado inicial de confirmación
          this.estadoProcesoConfirmacion = 0
          return
      }

      // confirmo el pedido
      this.$store.dispatch('pedidos/confirmarPedido', { id: idPedido })
      .then(data =>
      {
        if(data.CodigoResultado === 0)
        {
          // indico que se confirmó el pedido
          this.estadoProcesoConfirmacion = 2;
          showSuccess(this.$t('PEDIDO_confirmado_success'));
          this.$store.dispatch("pedidos/getPedido", { id: idPedido, idUsuario: this.idUsuario })
            .then(data =>
            {
              if(data.CodigoResultado === 0)
              {
                var numero = JSON.parse(data.Datos).Numero;
                // espero X milisegundos y continúo con la ejecución
                setTimeout(() => this.$router.push({ name: "Pedidos", params: { numeroPedido: numero } }), 3000)
              }
              else
              {
                mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado);
              }
            })
        }
        else
        {
          mostrarMensajeInternacionalizado(data.CodigoResultado, data.DescripcionResultado)

          // vuelvo al estado inicial de confirmación
          this.estadoProcesoConfirmacion = 0
        }
      })
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: var(--main-color);color: #fff;font-weight: bold;";
      }
    },
  },
  mounted() {
    this.init();

  }
};
</script>

<style scoped>
.idCabecera
{
  color: gray;
  font-size: 10px;
  padding-bottom: 5px
}
.el-icon-question {
  cursor: pointer;
}
.loaderContainer {
  text-align: center;
}

.loaderContainer i {
  font-size: 40px;
  color: var(--main-color);
}
.loaderContainer .text {
  font-size: 11px;
  margin-top: 5px;
  color: var(--main-color);
}
.loader {
  margin-left: 5%;
  color: #999;
}
.container {
  display: inline-block;
  padding: 0;
  width: 95%;
  margin: 0 auto;
}
.card_body {
  text-align: left;
}
.total {
  background-color: var(--main-color);
  color: #ffffff;
  font-weight: bold;
  padding: 0 20px 10px;
}
.blackLabel {
  text-align: left;
  margin: 12px 0 4px 15px;
  justify-content: center;
  font-weight: bold;
}
.el-divider {
  margin: 2px 0 2px 0;
}
.total .label {
  font-size: 1.5em;
}
.el-card__body {
  padding: 0px !important;
}
.contenedores {
  margin: 0px 20px 0 0;
}
.title {
  font-size: 24px;
  font-weight: bold;
  line-height: 26px;
  padding: 0 0 7px;
}
.subtitulo {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.cabecera .subtitulo {
  font-size: 16px;
}

.importacionDetalles .subtitulo {
  color: var(--main-color);
  margin-bottom: 5px;
}

.importacionDetalles button {
  width: 100%;
  margin-top: 20px;
}

.resultadoExportacion {
  font-size: 13px;
  font-weight: bold;
  text-align: center;
}

.resultadoExportacion .filasProcesadas {
  color: #2b47af;
  margin-bottom: 5px;
}

.resultadoExportacion .filasExitosas {
  color: #499c4d;
  margin-bottom: 5px;
}

.resultadoExportacion .filasConError {
  color: #f44336;
  margin-bottom: 10px;
}

.detallePedido {
  background: rgba(233, 233, 233, 0.959);
  padding: 0 20px 10px;
}
.botonImportar {
  background: white;
  color: var(--main-color);
  border-color: var(--main-color);
}
.sub-title {
  padding: 3px 0px 10px 0px;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}

.btnContainer.pedido {
  text-align: left;
  margin-top: 30px;
}
.label {
  font-size: 14px;
  text-align: left;
  padding: 10px 0px;
}
.label.col1 {
  margin-left: 15px;
  justify-content: center;
}
.greyLabel {
  color: #6b6b6b;
  font-weight: normal;
  padding: 10px 0px;
  text-align: left;
}
.input {
  box-sizing: border-box;
  display: inline-block;
  outline: 0;
}

.select,
.textarea {
  padding: 2px 0px;
  display: grid;
}

.textarea {
  border-radius: 4px;
  min-height: 90px;
}

.card_list {
  min-height: 60px;
  -webkit-flex-direction: column; /* Safari 6.1+ */
  display: flex;
  flex-direction: column;
}
.card_list_item {
  position: relative;
}
.card_list_item:nth-child(odd) {
  background: var(--main-color)1a;
}
.iconContainer {
  cursor: pointer;
  text-align: right;
}
.iconContainer .el-icon-circle-plus {
  cursor: pointer !important;
  font-size: 38px;
  color: var(--main-color);
  text-align: left;
  margin-bottom: 5px;

}
.bordes_body {
  padding: 20px 20px 10px;
}
.precio {
  text-align: right;
}
.leyenda {
  color: rgba(0, 0, 0, 0.644);
}
.detallePedido .label {
  padding: 2px 0px;
}
.detallePedido .blackLabel {
  margin: 0 0 0 15px;
  padding: 3px 0px;
}
@media (max-width: 600px) {
  .card_list {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  }
  .title {
    margin: 0px;
  }
}

@media (max-width: 1200px) {
  .container {
    flex-direction: column;
  }
  .container_col_1 {
    flex: 1;
    width: 100% !important;
  }
  .container_col_2 {
    flex: 1;
    width: 100% !important;
    margin-top: 20px;
  }
  .btnContainer.pedido {
    text-align: center;
    margin-top: 20px;
  }
}
</style>

<style>
.btnContainer.pedido.hidden-md-and-up {
  text-align: left;
  margin-bottom: 10px;
}
.btnContainer.pedido.hidden-md-and-up .botonImportar {
  padding: 5px 5px !important;
}

.el-table .nuevo-pedido th > .cell {
    color: #000000 !important;
}
</style>
